import "vant/es/toast/style";
import _Toast from "vant/es/toast";
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, vShow as _vShow, normalizeClass as _normalizeClass, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/componentImg/comment_icon.png';

const _withScopeId = n => (_pushScopeId("data-v-2c997935"), n = n(), _popScopeId(), n);

const _hoisted_1 = {
  class: "bottom-comment-view"
};

const _hoisted_2 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1));

const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "img"
}, null, -1));

import { ref, onMounted } from 'vue';
import request from '@/api';
import composition from '@/composition';
import LikeBtn from '../common/like-btn.vue';
import { qtComment } from '@/composition/qt';
import ua from '@/utils/platform';
export default {
  props: {
    post: Object
  },
  emits: ['finishComment'],

  setup(__props, {
    emit
  }) {
    const props = __props;
    const {
      loginHandle,
      throttle
    } = composition();
    const postItem = ref(props.post); // 输入状态

    const inputing = ref(0); // 文字内容

    const commentValue = ref(''); // 失去焦点

    const closeInput = () => {
      document.getElementById('comment-input').blur();
      inputing.value = 0;
    }; // 提交评论


    const submitComment = throttle(() => {
      if (commentValue.value.length == 0) {
        // 未填入内容
        return;
      }

      _Toast.loading({
        message: '发送评论中...',
        duration: 0,
        forbidClick: true
      });

      console.log('postItem.value', postItem.value);
      request.submitPostComment(postItem.value.id, commentValue.value).then(() => {
        qtComment(props.post);
        commentValue.value = '';

        _Toast({
          message: '评论成功',
          position: 'bottom'
        });

        closeInput();
        emit('finishComment');
      }).catch(error => {
        _Toast.fail(error.message);
      });
    }); // [埋点] 点击评论按钮

    const pocPostComment = () => {
      const item = postItem.value;
      const isMini = ua.isMini;
      const eventName = isMini ? 'fsplusmp_comment_click' : 'fsplush5_comment_click';
      let _poc_event_params = {
        button_name: isMini ? '帖子详情页' : undefined,
        content_id: item.id,
        user_code: item.memberId,
        author_name: item.memberNickname
      }; // eslint-disable-next-line no-undef

      qaplus.event.record(eventName, 2101, _poc_event_params); // eslint-disable-next-line no-undef

      pocplus.event.record(eventName, _poc_event_params);
    };

    onMounted(() => {
      // 成为焦点
      document.getElementById('comment-input').onfocus = () => {
        inputing.value = 1;
        loginHandle();
      };
    });
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", {
        class: "input-wrap",
        onClick: pocPostComment
      }, [_hoisted_2, _withDirectives(_createElementVNode("input", {
        id: "comment-input",
        type: "text",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => commentValue.value = $event),
        placeholder: "说两句..."
      }, null, 512), [[_vModelText, commentValue.value]])]), _withDirectives(_createVNode(LikeBtn, {
        item: __props.post
      }, {
        main: _withCtx(({
          record
        }) => [_createElementVNode("div", {
          class: _normalizeClass(['like-wrap', record.loveState ? 'liked-wrap' : ''])
        }, [_hoisted_3, _withDirectives(_createElementVNode("span", {
          class: "count"
        }, _toDisplayString(record.loveCount), 513), [[_vShow, record.loveCount > 0]])], 2)]),
        _: 1
      }, 8, ["item"]), [[_vShow, inputing.value == 0]]), _withDirectives(_createElementVNode("div", {
        class: _normalizeClass(['send-btn', commentValue.value.length == 0 ? 'dis-btn' : '']),
        onClick: _cache[1] || (_cache[1] = (...args) => _unref(submitComment) && _unref(submitComment)(...args))
      }, "发送", 2), [[_vShow, inputing.value == 1]])]), _withDirectives(_createElementVNode("div", {
        class: "mask",
        onClick: closeInput
      }, null, 512), [[_vShow, inputing.value]])], 64);
    };
  }

};